export default __webpack_public_path__ + "static/MediaContentSix-90be93a0903bd7c8fb0b42a3642b76fe.webp";